import { extend} from 'vee-validate';
import { required, email, } from 'vee-validate/dist/rules';
import { ValidationRule } from 'vee-validate/dist/types/types';

// Install rules
extend('required', {
  message: (field: string) => "required",
  computesRequired: true,
  validate: required.validate,
  params: required.params,
} as ValidationRule);

extend('email', {
  message: (field: string) => "format_error",
  computesRequired: true,
  validate: email.validate,
  params: email.params,
} as ValidationRule);